import { useDetector } from './useDetector'
import { USER_LEVEL_KEY } from '~/api/interface'

export function usePermission() {
  const { isAdmin, isTeamRight } = useDetector()
  const userInfo = useUserInfo()

  // 用于检测版本
  function checkUserLevel(versions: USER_LEVEL_KEY[]): boolean {
    return versions.includes(
      userInfo.value?.rights_type || USER_LEVEL_KEY.UN_AUTHORIZED
    )
  }

  // 用于检测是否可以购买存储
  const canBuyStorage = computed(() => {
    if (
      checkUserLevel([USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.PERSONAL_LITE])
    ) {
      return true
    }
    return (
      checkUserLevel([
        USER_LEVEL_KEY.TEAM_LIGHT,
        USER_LEVEL_KEY.ORG_STANDARD,
        USER_LEVEL_KEY.ORG_FLAGSHIP,
      ]) && isAdmin.value
    )
  })

  // 用于检测是否可以购买言币，这个属性用于判断是否可以展示
  const canBuyCredit = computed(() => {
    if (userInfo.value?.is_expired) {
      return false
    }

    // 个人版
    if (
      checkUserLevel([USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.PERSONAL_LITE])
    ) {
      return true
    }

    // 团队版且是管理员
    if (checkUserLevel([USER_LEVEL_KEY.TEAM_LIGHT]) && isAdmin.value) {
      return true
    }

    return false
  })

  // 用以检测是否可以增购席位
  const canAddSubAccount = computed(() => {
    return (
      checkUserLevel([
        USER_LEVEL_KEY.TEAM_LIGHT,
        // USER_LEVEL_KEY.ORG_STANDARD,
        // USER_LEVEL_KEY.ORG_FLAGSHIP,
      ]) &&
      isAdmin.value &&
      isGlobalVersion()
    )
  })

  // 用于检测是否可以对公转账
  const grantCorporateTransfer = (rightType?: USER_LEVEL_KEY) => {
    // 如果是及海外，则不行
    if (isGlobalVersion()) {
      return false
    }
    // 如果当前是团队账号，那需要是 admin
    if (isTeamRight.value && isAdmin.value) {
      return true
    }
    // 如果当前是个人账号，那需要购买的是团队套餐
    if (!isTeamRight.value && rightType) {
      return [
        USER_LEVEL_KEY.TEAM_LIGHT,
        USER_LEVEL_KEY.ORG_STANDARD,
        USER_LEVEL_KEY.ORG_FLAGSHIP,
      ].includes(rightType)
    }
    return false
  }

  // 用于检测是否可以复制到团队空间
  const grantCopyToTeam = (
    mediaType: RESOURCE_TYPE,
    collectionType: COLLECTION_MAP
  ) => {
    // 是团队账号, 且资源类型不是 任务
    if (isTeamRight.value) {
      // 作品，成片，成片模板，一律支持复制到团队
      if (
        [
          COLLECTION_MAP.OPUS,
          COLLECTION_MAP.PIECES,
          COLLECTION_MAP.PIECES_TEMPLATE,
          COLLECTION_MAP.SOURCE, // 修改为非定制人物也可复制
        ].includes(collectionType)
      ) {
        return true
      }

      // return true
      // 资源类型，除了 人物 外都支持复制到团队
      // return (
      //   mediaType !== RESOURCE_TYPE.PERSON &&
      //   collectionType === COLLECTION_MAP.SOURCE
      // )
    }
    return false
  }

  return {
    canBuyCredit,
    canBuyStorage,
    canAddSubAccount,
    grantCorporateTransfer,
    grantCopyToTeam,
  }
}
